// Shim for expo-file-system on web
// This prevents errors when importing expo-file-system on web
const FileSystem = {
  downloadAsync: () => {
    console.warn('FileSystem is not available on web');
    return Promise.resolve({ uri: '' });
  },
  deleteAsync: () => Promise.resolve(),
  copyAsync: () => {
    console.warn('FileSystem.copyAsync is not available on web');
    return Promise.resolve();
  },
  cacheDirectory: '',
  documentDirectory: '',
};

export default FileSystem;
export { FileSystem };
export const downloadAsync = FileSystem.downloadAsync;
export const deleteAsync = FileSystem.deleteAsync;
export const copyAsync = FileSystem.copyAsync;
export const cacheDirectory = FileSystem.cacheDirectory;
export const documentDirectory = FileSystem.documentDirectory;
